module.exports = __webpack_public_path__ + "static/media/info_bubble.700078e0.ico";